import api from "./api";
import {customApi} from "./customSdpApiService";

export const uploadMobilyRevenueReport = async (data)=>{
  try {
    const response = await api.post('/LocalApi/UploadMobilyRevenueReport', data);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}


export const uploadZainSubscriptionReport = async (data)=>{
  try {
    const response = await api.post('/LocalApi/UploadZainSubscriptionReport', data);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const uploadZainRevenueReport = async (data)=>{
  try {
    const response = await api.post('/LocalApi/UploadZainRevenueReport', data);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}


export const uploadZainFinancialReport = async (data)=>{
  try {
    const response = await customApi.post('/add-zain-financial', data);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}
